<template>
    <div>
        <a-dropdown>
            <div class="cursor-pointer text-blue-500">{{ userInfo.jpID }}</div>
            <template #overlay>
                <a-menu>
                    <a-menu-item>
                        <div @click="onUpdatePassword()">
                            {{ $t('l_Password') }}
                        </div>
                    </a-menu-item>
                    <a-menu-item>
                        <div @click="onSignOUt()" class="cursor-pointer text-red-500">
                            {{ $t('l_Sign_out') }}
                        </div>
                    </a-menu-item>
                </a-menu>
            </template>
        </a-dropdown>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters({
            userInfo: 'userInfo'
        })
    },
    methods: {
        onSignOUt() {
            this.$store.commit('signOut')
        },
        onUpdatePassword() {
            this.$router.push({ name: 'UpdatePassword' })
        }
    }
}
</script>

<style lang="scss" scoped></style>
